import { render, staticRenderFns } from "./VisualAppearanceOptions.vue?vue&type=template&id=98aefa78&"
import script from "./VisualAppearanceOptions.vue?vue&type=script&lang=js&"
export * from "./VisualAppearanceOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports